import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <main className="page">
      <h1>Page not found</h1>
      <p className="version">This page doesn't exist yet.</p>
      <Link to="/">Go to the home page</Link>
    </main>
  );
}
